import { createElement } from "rax";
import * as Dinamic from "@ali/dinamic";
import { View, bindGestureEvent } from "@ali/dinamic-views-icbu-fork";

// ALIVideoView 文档： https://yuque.antfin-inc.com/gst5q5/hk0sez/ii7xm8
// mode:
//    1. ALIVideoViewModeJustPlay
//    2. ALIVideoViewModeHavePlayBtn
//    3. ALIVideoViewModeHavePlayBtnProgressDuration
//    4. ALIVideoViewModeHavePlayBtnProgressDurationMute
//    5. ALIVideoViewModeCompletePlayer
// 
class ALIVideoView extends View {
  _data = {};
  _mode = 'ALIVideoViewModeJustPlay';
  _autoPlay = false;

  _timer = null;

  constructor(props) {
    super(props);

    this.state = {
      isPlaying: false,
      isMuted: false
    };
  }
  componentWillMount() {
    this._preprocessingStyle();
  }

  componentDidMount() {
    // 开始播放
    this.$video.addEventListener('play', () => {
      this.startTimer();
      this.setState({ isPlaying: true });
    });

    this.$video.addEventListener('pause', () => {
      this.stopTimer();
      this.setState({ isPlaying: false });
    });

    // 播放结束
    this.$video.addEventListener('ended', () => {
      this.setState({ isPlaying: false });
    });
  }

  startTimer() {
    // 定时器拉取播放进度
    if (!this._timer) {
      if (needShowTimer(this._mode))
        this._timer = setInterval(() => {
          if (this.$video.duration > 0) {
            const progress = this.$video.currentTime / this.$video.duration;
            this.setState({ progress });
          }
        }, 1000);
    }
  }

  stopTimer() {
    if (this._timer) {
      clearInterval(this._timer);
    }
  }

  _preprocessingStyle() {
    this.setStyles({
      overflow: 'hidden'
    });
  }

  data(propValue) {
    this._data = propValue;
  }

  mode(propValue) {
    this._mode = propValue;
  }

  autoPlay(propValue) {
    this._autoPlay = propValue === '1';
  }

  renderView() {
    const videoEl = this.$video;
    let timeStr;
    let muted;

    if (videoEl) {
      // time
      const current = Math.ceil(videoEl.currentTime);
      const duration = Math.ceil(videoEl.duration);
      timeStr = `${current < 10 ? '0' : ''}${current}:${duration < 10 ? '0' : ''}${duration}`

      // muted
      muted = videoEl.muted;
    }

    const modeConfig = getModeConfig(this._mode);

    let otherAttr = {};
    if (this._autoPlay) {
      otherAttr['autoPlay'] = 'autoPlay';
      otherAttr['muted'] = '1';
    }
    if (modeConfig.originalControl) {
      otherAttr['controls'] = '1';
    }

    return (
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <video
          muted
          playsinline
          preload="none"
          poster={this._data.coverImg}
          style={{ ...DefaultStyle }}
          ref={$video => this.$video = $video}
          onClick={() => {
            if (modeConfig.playControl) {
              if (this.state.isPlaying) {
                this.$video.pause();
              } else {
                this.$video.play();
              }
              this.setState({ isPlaying: !this.state.isPlaying });
            }
          }}
          {...otherAttr}
        >
          <source src={this._data.videoUrl}></source>
        </video>
        {modeConfig.playControl && <PlayBtn visible={!this.state.isPlaying} />}
        {modeConfig.time &&
          <div style={{
            bottom: 0,
            width: '100%',
            height: '8vw',
            position: 'absolute'
          }}>
            <div style={{
              height: '1px',
              width: `${this.state.progress * 100}%`,
              backgroundColor: '#FF5000',
              transition: 'width 0.5s linear',
              position: 'absolute',
              bottom: 0,
              margin: '0 8px 0 8px',
            }} />
            <span style={{ position: 'absolute', right: '2vw', color: 'white' }}>{timeStr}</span>
            {modeConfig.mute &&
              <MuteBtn muted={muted} onClick={() => {
                const newMuted = !this.state.isMuted;
                this.setState({ isMuted: newMuted });
                this.$video.muted = newMuted;
              }} />}
          </div>}
      </div >
    );
  }
}

const DefaultStyle = {
  width: "100%",
  height: "100%"
}

class PlayBtn extends Dinamic.Component {
  render() {
    const style = {
      position: 'absolute',
      width: '10vw',
      height: '10vw',
      backgroundColor: 'rgba(0,0,0,0.2)',
      borderRadius: '50%',
      border: '2px solid white',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center'
    };
    return <div
      style={{
        ...style,
        ...{ visibility: (this.props.visible ? 'visible' : 'hidden') }
      }}
    >
      <img style={{
        width: "30%",
        height: 'auto'
      }} src="https://sc02.alicdn.com/kf/H6c9684a5796c47ec939d2fd1a3c3a6676.png" />
    </div>
  }
}

class MuteBtn extends Dinamic.Component {
  render() {
    const style = {
      position: 'absolute',
      width: '6vw',
      height: '6vw',
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderRadius: '50%',
      left: '2vw',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center'
    };

    return <div
      style={{
        ...style
      }}
      onClick={this.props.onClick}
    >
      <img style={{
        width: "40%",
        height: 'auto'
      }} src={this.props.muted ?
        "https://sc01.alicdn.com/kf/H9751bb7be71a4befa17de3964d283fc5Z.png" :
        "https://sc01.alicdn.com/kf/H5f852d8a75654a90bfb7eb84aaf63b28e.png"} />
    </div>
  }
}

function getModeConfig(mode) {

  const modeConfig = {
    playControl: false,
    progressBar: false,
    time: false,
    mute: false,
    originalControl: false
  };

  switch (mode) {
    case 'ALIVideoViewModeJustPlay':
      break;
    case 'ALIVideoViewModeHavePlayBtn':
      modeConfig.playControl = true;
      break;
    case 'ALIVideoViewModeHavePlayBtnProgressDuration':
      modeConfig.playControl = true;
      modeConfig.progressBar = true;
      modeConfig.time = true;
      break;
    case 'ALIVideoViewModeHavePlayBtnProgressDurationMute':
      modeConfig.playControl = true;
      modeConfig.progressBar = true;
      modeConfig.time = true;
      modeConfig.mute = true;
      break;
    case 'ALIVideoViewModeCompletePlayer':
      modeConfig.originalControl = true;
      break;
    default:
      break;
  }

  return modeConfig;
}

function needShowTimer(mode) {
  return mode === 'ALIVideoViewModeHavePlayBtnProgressDuration' || mode == 'ALIVideoViewModeHavePlayBtnProgressDurationMute';
}

Dinamic.registerView("ALIVideoView", ALIVideoView);

export default ALIVideoView;